import API from '../services/api';
import ApiService from '../utils/api.util';
import { API_CONSTANTS } from "@/constants/api.constant";
import { useConversationStore } from "@/stores/conversation";
import { ConversationMediaType, MessageOutboundState } from "@/types/ConversationTypes";
import { delay, getMediaTypeByMimeType } from "@/utils/index";
import CoreService from "@/services/core.service";
import { Views } from "@/types/ConfigTypes";
import { outboundMessage } from "@/utils/outbound-message";
import { toast } from "../main";
import { t } from "@/utils/lang.util";
import clone from "lodash/clone";
import DomUtil from "@/utils/dom.util";
import SocketService from "@/services/socket.service";
import ParentService from "@/services/parent.service";
let conversationStore;
export default {
    getConversationStore() {
        if (!conversationStore) {
            conversationStore = useConversationStore();
        }
        return conversationStore;
    },
    async fetchList() {
        // await delay(600)
        return ApiService.request('get', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS)
            .then((resp) => {
            this.getConversationStore().setConversations(resp.data.conversations);
            this.getConversationStore().setArchivedCount(resp.data.archivedCount || 0);
            if (resp.data.conversations.length) {
                // connect to websocket in case of any open conversations
                SocketService.connect();
            }
        })
            .catch((error) => {
            throw new Error(error);
        });
    },
    async fetchArchivedList() {
        // await delay(600)
        return ApiService.request('get', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/archived')
            .then((resp) => {
            return resp.data;
        })
            .catch((error) => {
            throw new Error(error);
        });
    },
    get(conversationId) {
        return ApiService.request('get', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + conversationId)
            .then((resp) => {
            for (let i = 0; i < resp.data.items?.length; i++) {
                resp.data.items[i] = this.transformMessage(resp.data.id, resp.data.items[i]);
            }
            return resp;
        })
            .catch((error) => {
            throw new Error(error);
        });
    },
    transformMessage(conversationId, item) {
        // attachments
        if (item.attachments?.length) {
            item['media'] = [];
            for (let i = 0; i < item.attachments.length; i++) {
                const mimeType = item.attachments[i].mimeType;
                item['media'][i] = {
                    content: {
                        id: item.attachments[i].id,
                        // url: ApiService.getAbsPath()+API.CONVERSATIONS+'/'+conversationId+'/attachment/'+item.attachments[i].id,
                        name: item.attachments[i].name,
                        mimeType: mimeType,
                        type: getMediaTypeByMimeType(mimeType)
                    }
                };
            }
        }
        return item;
    },
    getCurrentConversationId() {
        return this.getConversationStore().getCurrentConversationId;
    },
    getLastConversationId() {
        return this.getConversationStore().getLastConversationId;
    },
    generateTempMsgId() {
        return Date.now() * -1; // make id negative to distinguish between real msg ids (positive) and temp ids (negative)
    },
    async addOutboundMessage(convId, message, attachment = null, localOnly = false) {
        DomUtil.enableSmoothConversationScrolling(true);
        if ((message === undefined || !message) && !attachment)
            return;
        this.isAttachmentPanelOpened = false;
        const msg = clone(outboundMessage);
        msg.id = this.generateTempMsgId();
        msg.body = message;
        if (localOnly) {
            // print message locally on messenger only
            msg.status = MessageOutboundState.SENT;
        }
        if (message.indexOf('/giphy') === 0) {
            const q = message.substr(7);
            const resp = await this.queryGiphy(q);
            if (resp.data.data.images) {
                msg.body = q;
                msg.media = [{
                        content: {
                            name: 'giphy',
                            url: resp.data.data.images['downsized_medium'].url,
                            type: ConversationMediaType.IMAGE,
                            mimeType: "image/gif",
                        },
                        caption: q,
                    }];
            }
            else {
                toast.error(t('common.toast.giphy_no_results'), { position: 'bottom' });
                // this.$toast.show(this.$t('common.toast.giphy_no_results'), { position: 'bottom' });
            }
        }
        // this.lastMessageSentStatusMessage = t('conversation.status.sending')
        // print message locally
        //todo: encapsulate
        if (attachment) {
            msg.media = [{
                    content: {
                        name: attachment.name,
                        url: attachment.url,
                        type: attachment.type,
                        mimeType: attachment.mimeType,
                    },
                    caption: message,
                }];
        }
        this.getConversationStore().addMessage(convId, msg);
        if (!localOnly) {
            let response;
            try {
                response = await this.sendMessageToServer(convId, msg, attachment);
            }
            catch (e) {
                toast.error(t('common.toast.message_sent_error'), { position: 'bottom' });
                // this.$toast.show(this.$t('common.toast.message_sent_error'));
                this.lastMessageSentStatusMessage = '';
            }
            if (ApiService.isSuccess(response)) {
                return true;
            }
            return false;
        }
    },
    async sendMessageToServer(id, msg, attachment) {
        // await delay(2000)
        const params = {
            body: msg.body
        };
        if (!attachment) {
            return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + id + '/message', params)
                .then(async (res) => {
                // await delay(2000)
                this.getConversationStore().setMessageStatus(id, msg.id, MessageOutboundState.SENT);
                this.getConversationStore().setMessageId(id, msg.id, res.data.id);
                return res;
            })
                .catch((error) => {
                this.getConversationStore().setMessageStatus(id, msg.id, MessageOutboundState.SENT_FAILURE);
                throw new Error(error);
            });
        }
        else {
            // with attachment
            let data = new FormData();
            data.append('file', attachment.file, attachment.name);
            if (params['meta']) {
                data.append('meta', JSON.stringify(params['meta']));
            }
            // caption
            if (msg.body) {
                data.append('body', msg.body);
            }
            const header = {
                'Content-Type': 'multipart/form-data'
            };
            return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + id + '/attachment', data, header)
                .then((res) => {
                this.getConversationStore().setMessageStatus(id, msg.id, MessageOutboundState.SENT);
                this.getConversationStore().setMessageId(id, msg.id, res.data.id);
                return res;
            })
                .catch((error) => {
                this.getConversationStore().setMessageStatus(id, msg.id, MessageOutboundState.SENT_FAILURE);
                throw new Error(error);
            });
        }
    },
    sendLastMessageSeen(id, ts) {
        const params = { ts: ts };
        return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + id + '/read', params)
            .then(async (res) => {
            return res;
        });
    },
    queryGiphy(q) {
        const url = 'https://api.giphy.com/v1/gifs/random?api_key=CjKXn800FEiwuuywB4U0nMaPTpWP6jgG&limit=25&offset=0&rating=r&lang=en&tag=' + q;
        return ApiService.requestExternalUrl('get', url).catch((error) => {
            throw new Error(error);
        });
    },
    isStoreLoaded() {
        return this.getConversationStore().isStoreLoaded;
    },
    loadMedia(conversationId, itemId) {
        const headers = {};
        const msg = this.getConversationStore().getMessageById(conversationId, itemId);
        msg.media?.forEach(async (att, i) => {
            const url = API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + conversationId + '/attachment/' + att.content.id;
            await delay(400);
            ApiService.request('get', url, {}, headers, 'blob')
                .then((resp) => {
                this.getConversationStore().setUrl(conversationId, itemId, i, window.URL.createObjectURL(resp.data));
                return resp;
            })
                .catch((error) => {
                throw new Error(error);
            });
        });
    },
    start() {
        SocketService.connect();
        CoreService.sendOnlineHeartbeat().then(() => { });
        const params = {
            vars: {
                _HOST_SOURCE_URL: ParentService.getRemoteHostInfo()?.url
            }
        };
        return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS, params).catch((error) => {
            throw new Error(error);
        });
    },
    updateUserField(type, name, value) {
        const params = {
            type: type,
            name: name,
            value: value
        };
        return ApiService.request('patch', API_CONSTANTS.API_URI_PREFIX + API.USER + '/update', params).catch((error) => {
            throw new Error(error);
        });
    },
    rateConversation(conversationId, score) {
        const params = {
            score: score
        };
        return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + conversationId + '/rate', params).catch((error) => {
            throw new Error(error);
        });
    },
    sendIsTyping(conversationId, isTyping = true) {
        const params = {
            typing: isTyping
        };
        return ApiService.request('post', API_CONSTANTS.API_URI_PREFIX + API.CONVERSATIONS + '/' + conversationId + '/typing', params).catch((error) => {
            throw new Error(error);
        });
    },
    openLastOrStartNewConversation(params = null) {
        DomUtil.enableSmoothConversationScrolling(false);
        const convId = this.getCurrentConversationId() || this.getLastConversationId();
        CoreService.push(Views.CONVERSATION, {
            id: convId,
            initialMessage: params?.sendMessage
        });
        return convId;
    }
};
